export default {
  path: '/reports/facility-summary',
  preload: false,
  middlewares: [{
      "rms_ui/validatePermissionsMiddleware": [
          ["report.advanced_reports"],
          "/"
      ]
  }],
}